module.exports = __webpack_public_path__ + "img/lexi_nd2lke.90452901.png";